<template>
  <el-autocomplete
    class="input-with-select"
    :placeholder="texts?.placeholder"
    v-model="searchkey"
    :fetch-suggestions="querySearchAsync"
    @select="handleSelect"
  >
    <template #prefix
      ><img style="width: 14px; height: 14px" :src="searchIcon" alt=""
    /></template>
  </el-autocomplete>
</template>

<script>
import { mapState } from "vuex"
import { getMedproArticleList } from "../../api/blog"
import { languageMap } from "@/data/list.js"
export default {
  name: "AutoComplete",
  data() {
    return {
      searchIcon: require("@/assets/icons/search.svg"),
      searchkey: "",
    }
  },
  computed: {
    ...mapState(["texts", "menulist", "selectedLanguage"]),
    restaurants() {
      return this.menulist.map((item) => ({
        value: item.title,
        id: item.id,
      }))
    },
  },
  methods: {
    handleSelect(e) {
      this.$router.push({
        path: "/blog",
        query: {
          blogid: e.id,
        },
      })
      this.searchkey = ""
    },
    async querySearchAsync(queryString, cb) {
      if (queryString === "") return cb([])
      try {
        const { data } = await getMedproArticleList({
          searchWord: queryString,
          languageFlag: languageMap[this.selectedLanguage].id,
        })
        const filterBlogs =
          data.map(({ id, title }) => ({ id, value: title })) || []
        cb(filterBlogs)
      } catch (error) {
        cb([])
      }
    },
  },
}
</script>
<style lang="scss">
.el-input {
  font-size: 15px !important;
  .el-input__prefix {
    display: flex;
    align-items: center;
    left: 20px !important;
  }
  .el-input__inner {
    padding-left: 45px !important;
  }
}
</style>
